import React, { memo, useEffect, useRef, useState } from "react";
import "./styles.scss";
import { useDispatch } from "react-redux";
import { setNavbarParams, setText } from "../../store/navbar";
import { setLinks, showLinks } from "../../store/sidebar";
import {
  getStudentEndPoints,
  MustIncludedSidebarItems,
} from "../../constants/sidebar";
import SummaryCard from "../../components/Classroom/StudentClassroom/SummaryCard";
import { Button, Image, ProgressBar, Spinner } from "react-bootstrap";
import EnrollementInfoCard from "../../components/Classroom/StudentClassroom/EnrollementInfoCard";
import StatusChip from "../../components/Classroom/StatusChip";
import { formatAMPM, getStartAndEndDate } from "../../utils/formater";
import ActivityTabsHeader from "../../components/StudentDashboard/ActivityTabsHeader/ActivityTabsHeader";
import { activitesTabsList } from "./constants.js/constants";
import RecentAttendedLectures from "../../components/StudentDashboard/ActivitesComponents/RecentAttendedLectures";
import {
  getClassActivitesDetails,
  getIeltsClassActivitesDetails,
  getSummaryDetails,
} from "../../utils/dashboard";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import PracticePerformance from "../../components/StudentDashboard/ActivitesComponents/PracticePerformance";
import TestPerformance from "../../components/StudentDashboard/ActivitesComponents/TestPerformance";
import FullLengthExams from "../../components/StudentDashboard/ActivitesComponents/FullLengthExams";
import DashboardDropdown from "../../components/StudentDashboard/Dropdown/dropdown";
import WhatsNew from "../../components/StudentDashboard/WhatsNew/WhatsNew";
import { useSelector } from "react-redux";
import {
  getUserInformation,
  getUserPermission,
  getUserRole,
} from "../../store/userRole";
import {
  getAllLiveClassesOfClassroom,
  getLiveClassesOfClassroom,
  getSingalClassroomData,
} from "../../utils/classrooms";
import { joinLiveClass } from "../../utils/liveClasses";
import { fetchSubscription } from "../../store/subscriptionSlice";
import withSubscriptionCheckButton from "../../components/Common/withSubscriptionCheckButton";
import { isSafari } from "../StudentPages/LiveClasses/utils";
import { extractModulesInMentionedOrder } from "../../utils/validations";
import RecentMistakesWidget from "../../components/StudentDashboard/WroongQuestionsReport/RecentMistakesWidget";

const PlayRecordingButton = withSubscriptionCheckButton(Button, "Live Classes");

const StudentDashboard = ({ isMobileView }) => {
  const roleOfTheUser = useSelector(getUserRole);
  const rolePermissions = useSelector(getUserPermission);
  const [isLoading, setIsLoading] = useState(false);
  const isCallInProgress = useRef(false);
  const [thumbnailLoader, setThumbnailLoader] = useState(false);
  const [classroomName, setClassroomName] = useState(false);
  const [subjectsMap, setSubjectsMap] = useState({});
  const [courseName, setCourseName] = useState(false);
  const [hasIeltsExams, setHasIeltsExams] = useState(false);
  const [liveClassesLoader, setLiveClassesLoader] = useState(false);
  const [liveClassesList, setLiveClassesList] = useState([]);
  const userInformation = useSelector(getUserInformation);
  const [clickTimes, setClickTimes] = useState(1);
  const [pagesCount, setPagesCount] = useState(1);
  const [summaryDetails, setSummaryDetails] = useState({});
  const [activitesDetails, setActivitesDetails] = useState([]);
  const { id: classroomId } = useParams();
  const [liveclassesSelection, setLiveclassesSelection] = useState("week");
  const [activitySelection, setActivitySelection] = useState("today");
  const [activeTab, setActiveTab] = useState("recent-attended-lecture");
  const [activitesLoader, setActivitesLoader] = useState(false);
  const [thumbnail, setThumbnail] = useState("");
  const [modules, setModules] = useState([]);
  const [courseId, setCourseId] = useState("");
  const [syncLiveClasses, setSyncLiveClasses] = useState(false);
  const skipFirst = useRef(false);

  const navigate = useNavigate();

  const selectionValues = {
    today: "Today",
    week: "This week",
    month: "This Month",
  };

  const dispatch = useDispatch();

  const startLiveClass = async (liveclassid, meetingId, password) => {
    const isSafariBrowser = isSafari();
    try {
      setIsLoading(true);
      const formatData = { meetingID: meetingId, password: password };
      const payload = JSON.stringify(formatData);
      const response = await joinLiveClass(liveclassid, payload, "join");
      if (isSafariBrowser) {
        if (response.data.url) {
          window.location.href = response?.data?.url;
        }
      } else {
        if (response.data.url) {
          window.open(response.data.url, "_blank", "noopener,noreferrer");
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching classrooms:", error.message);
      // Handle error, show a message to the user, etc.
    }
  };

  const getClassroomDetails = async () => {
    try {
      setThumbnailLoader(true);
      const response = await getSingalClassroomData(classroomId);
      if (response?.data?.classRoom) {
        if (response?.data?.classRoom?.thumbnail?.length) {
          setThumbnail(response?.data?.classRoom?.thumbnail);
        }
        if (response?.data?.classRoom?.name) {
          setClassroomName(response?.data?.classRoom?.name);
          setCourseName(response?.data?.classRoom?.course?.name);
          setCourseId(response?.data?.classRoom?.course?._id);
          setModules(response?.data?.classRoom?.modulesIncluded);
          setHasIeltsExams(response?.data?.classRoom?.hasIeltsExams)
          const subjectMapList = {}
          response?.data?.classRoom?.course?.subjects?.forEach(subject => {
            subjectMapList[subject?._id] = subject?.name
          })
          setSubjectsMap(subjectMapList)
        }
      }
      setThumbnailLoader(false);
    } catch (error) {
      console.error("Error fetching classrooms:", error);
      setThumbnailLoader(false);
      // Handle error, show a message to the user, etc.
    }
  };
  useEffect(() => {
    getClassroomDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const heading = "student-dashboard";
    let userId = userInformation?._id;
    dispatch(setText(heading));
    dispatch(setNavbarParams(`My Classrooms | ${classroomName}`));
    dispatch(fetchSubscription({ classRoomId: classroomId, userId }));
    const defaultItems = [
      ...getStudentEndPoints(
        classroomId,
        roleOfTheUser,
        false,
        rolePermissions,
      ),
    ];
    const sidebarItems = defaultItems.filter(
      (item) =>
        modules.includes(item?.value) ||
        MustIncludedSidebarItems.includes(item?.value),
    );
    const indOfItem = sidebarItems?.findIndex(
      (item) => item.value === "Dashboard",
    );
    if (indOfItem !== -1) {
      sidebarItems[indOfItem].selected = true;
    }
    dispatch(setLinks(extractModulesInMentionedOrder(sidebarItems, modules)));
    dispatch(showLinks());
  }, [
    classroomId,
    classroomName,
    dispatch,
    modules,
    roleOfTheUser,
    rolePermissions,
    userInformation?._id,
  ]);

  const getStudentSummaryDetails = async () => {
    try {
      setIsLoading(true);
      const response = await getSummaryDetails(classroomId);
      if (response.ok) {
        setSummaryDetails(response.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching classrooms:", error.message);
      // Handle error, show a message to the user, etc.
    }
  };

  const getLiveClassesListOfClassroom = async (skipLoader = false) => {
    try {
      if (isCallInProgress.current) {
        return;
      }
      if (!skipLoader) {
        setLiveClassesLoader(true);
      }
      isCallInProgress.current = true;
      const dates = getStartAndEndDate(liveclassesSelection);

      // Fetch both responses
      const response = await getAllLiveClassesOfClassroom({
        classroomId: classroomId,
      });

      const resp = await getLiveClassesOfClassroom({
        classroomId: classroomId,
        startDate: new Date(new Date().toDateString()).toISOString(),
        endDate: dates.endDate,
        page: 0,
        pageSize: 40,
      });

      if (response.ok && resp.ok) {
        // Combine liveClasses from both responses with response's liveClasses first
        const combinedLiveClasses = [
          ...(response?.data?.liveClasses || []),
          ...(resp?.data?.liveClasses || []),
        ];

        setLiveClassesList(combinedLiveClasses);
      } else {
        console.error(
          "Error fetching live classes:",
          response.error || resp.error,
        );
      }

      setLiveClassesLoader(false);
      isCallInProgress.current = false;
    } catch (error) {
      setLiveClassesLoader(false);
      isCallInProgress.current = false;
      console.error("Error fetching classrooms:", error.message);
      // Handle error, show a message to the user, etc.
    }
  };

  useEffect(() => {
    if (skipFirst.current) {
      getLiveClassesListOfClassroom(true);
    } else {
      skipFirst.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [syncLiveClasses]);
  useEffect(() => {
    getLiveClassesListOfClassroom();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classroomId, liveclassesSelection]);

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      setSyncLiveClasses(!syncLiveClasses);
    }, [30000]);
    //Clearing the interval
    return () => clearInterval(refreshInterval);
  }, [syncLiveClasses]);

  const getStudentActivitesDetails = async (isConcat = false, pageNo = 0) => {
    try {
      setActivitesLoader(true);
      const dataMapping = {
        "recent-attended-lecture": "lectures",
        "practice-performance": "practice",
        "test-performance": "test",
        "full-length-exams": "assessment",
      };
      if (dataMapping[activeTab] === "lectures") {
        setActivitesLoader(false);
        return;
      }
      const dates = getStartAndEndDate(activitySelection);
      let response = {}
      if(activeTab === 'full-length-exams' && hasIeltsExams) {
        response = await getIeltsClassActivitesDetails({
          classroomId,
          startDate: dates.startDate,
          page: pageNo !== 0 ? pageNo : clickTimes - 1,
          pageSize: 10,
        })
        if(response.data?.examAttempts) {
          response.data.examAttempts = response.data?.examAttempts?.map(activity => {
            return {
              ...activity,
              createdAt: activity.completedAt,
              name: activity?.examId?.title ?? '',
              timeSpent: activity.totalTimeSpent,
              courseId: {
                _id: courseId,
                name: courseName
              }
            }
          }) ?? []
        }
      } else {
        response = await getClassActivitesDetails({
          classroomId,
          startDate: dates.startDate,
          page: pageNo !== 0 ? pageNo : clickTimes - 1,
          pageSize: 10,
          examType: dataMapping[activeTab],
        });
      }
      if (response.data?.examAttempts) {
        if (response?.data?.count && response?.data?.count > 10) {
          setPagesCount(Math.ceil(response?.data?.count / 10));
        } else {
          setPagesCount(1);
        }
        if (isConcat) {
          setActivitesDetails([
            ...activitesDetails,
            ...response.data?.examAttempts,
          ]);
        } else {
          setActivitesDetails(response.data?.examAttempts);
        }
      }
      setActivitesLoader(false);
    } catch (error) {
      setActivitesLoader(false);
      console.error("Error fetching classrooms:", error.message);
      // Handle error, show a message to the user, etc.
    }
  };

  useEffect(() => {
    setClickTimes(1);
    getStudentActivitesDetails(false, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classroomId, activeTab, activitySelection]);
  useEffect(() => {
    getStudentSummaryDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classroomId]);

  const componentsMapping = {
    "recent-attended-lecture": (
      <RecentAttendedLectures
        isMobileView={isMobileView}
        classroomId={classroomId}
      />
    ),
    "practice-performance": (
      <PracticePerformance
        activitesList={activitesDetails}
        isMobileView={isMobileView}
        isShowLoadMore={pagesCount > clickTimes}
        classroomId={classroomId}
        loadMore={() => {
          setClickTimes(clickTimes + 1);
          getStudentActivitesDetails(true, clickTimes + 1);
        }}
      />
    ),
    "test-performance": (
      <TestPerformance
        activitesList={activitesDetails}
        isMobileView={isMobileView}
        classroomId={classroomId}
        isShowLoadMore={pagesCount > clickTimes}
        loadMore={() => {
          setClickTimes(clickTimes + 1);
          getStudentActivitesDetails(true, clickTimes + 1);
        }}
      />
    ),
    "full-length-exams": (
      <FullLengthExams
        activitesList={activitesDetails}
        classroomId={classroomId}
        isMobileView={isMobileView}
        isShowLoadMore={pagesCount > clickTimes}
        loadMore={() => {
          setClickTimes(clickTimes + 1);
          getStudentActivitesDetails(true, clickTimes + 1);
        }}
        roleOfTheUser={roleOfTheUser}
        courseName={courseName}
        hasIeltsExams={hasIeltsExams}
      />
    ),
  };

  if (isLoading || thumbnailLoader) {
    return <Loader />;
  }

  return (
    <div style={{ margin: "10px", paddingBottom: isMobileView ? "20px" : "" }}>
      <div className="row">
        <div className="col-6 col-lg-3" style={{ marginBottom: "24px" }}>
          <SummaryCard
            imageURl="/styled-playbutton.svg"
            isMobileView={isMobileView}
            value={summaryDetails?.totalQ_Answered}
            description="Questions Answered"
          />
        </div>
        <div className="col-6 col-lg-3" style={{ marginBottom: "24px" }}>
          <SummaryCard
            imageURl="/styled-tickbox.svg"
            isMobileView={isMobileView}
            value={summaryDetails?.timeSpentPractice}
            description="Time Spent Practicing"
          />
        </div>
        <div className="col-6 col-lg-3" style={{ marginBottom: "24px" }}>
          <SummaryCard
            imageURl="/styles-usersicons.svg"
            isMobileView={isMobileView}
            value={summaryDetails?.timeSpentTest}
            description="Time Spent on Tests"
          />
        </div>
        <div className="col-6 col-lg-3" style={{ marginBottom: "24px" }}>
          <SummaryCard
            imageURl="/styled-winingcup.svg"
            isMobileView={isMobileView}
            value={summaryDetails?.practiceAttempted}
            description="Practice Sets Attempted"
          />
        </div>
        <div className="col-6 col-lg-3" style={{ marginBottom: "24px" }}>
          <SummaryCard
            imageURl="/styled-winingcup.svg"
            isMobileView={isMobileView}
            value={summaryDetails?.testAttempted}
            description="Topic-wise Tests Attempted"
          />
        </div>
        <div className="col-6 col-lg-3" style={{ marginBottom: "24px" }}>
          <SummaryCard
            imageURl="/styled-winingcup.svg"
            isMobileView={isMobileView}
            value={summaryDetails?.assessmentAttempted}
            description="Full Length Exams Attempted"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-lg-6 d-flex flex-column" style={{ marginBottom: "24px" }}>
          <div className="suggestionCardTitleStyles">My Progress</div>
          <div className="card flex-grow-1" style={{ padding: "0px", borderRadius: "0px" }}>
            <div
              className="d-flex align-items-center"
              style={{
                padding: "16px 20px",
                backgroundColor: "#33140B",
                gap: "12px",
              }}
            >
              <Image
                src={userInformation.s3Key || "/ProfilePic.png"}
                roundedCircle
                className="profile-pic"
                style={{
                  height: "40px",
                  width: "40px",
                  objectFit: "cover",
                }}
              />
              <div>
                <div style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: "18px" }}>
                  {userInformation?.fullName}
                </div>
                <div style={{ fontSize: "12px", color: "#d3c8ff", lineHeight: "16px" }}>
                  {userInformation?.email}
                </div>
              </div>
            </div>
            <div style={{ padding: "20px" }}>
              <div style={{ marginBottom: "20px" }}>
                <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: "8px" }}>
                  <span style={{ fontSize: "13px", fontWeight: 500, color: "#1D2026" }}>
                    Course Work
                  </span>
                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#1D2026" }}>
                    {summaryDetails?.percentageCourseWork
                      ? Math.ceil(summaryDetails?.percentageCourseWork)
                      : 0}%
                  </span>
                </div>
                <ProgressBar
                  variant="success"
                  now={
                    summaryDetails?.percentageCourseWork
                      ? Math.ceil(summaryDetails?.percentageCourseWork)
                      : 0
                  }
                  style={{ height: "8px" }}
                />
              </div>
              <div>
                <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: "8px" }}>
                  <span style={{ fontSize: "13px", fontWeight: 500, color: "#1D2026" }}>
                    Live Classes
                  </span>
                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#1D2026" }}>
                    {summaryDetails?.percentageLiveClass
                      ? Math.ceil(summaryDetails?.percentageLiveClass)
                      : 0}%
                  </span>
                </div>
                <ProgressBar
                  now={
                    summaryDetails?.percentageLiveClass
                      ? Math.ceil(summaryDetails?.percentageLiveClass)
                      : 0
                  }
                  style={{ height: "8px" }}
                  className="progress-live-classes"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 d-flex flex-column" style={{ marginBottom: "24px" }}>
          <div className="suggestionCardTitleStyles">What's New</div>
          <WhatsNew courseId={courseId} />
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-lg-6" style={{ marginBottom: "24px" }}>
          <div className="suggestionCardTitleStyles">Upcoming Live Classes</div>
          <div className="card" style={{ padding: "0px", borderRadius: "0px" }}>
            <div
              className="d-flex justify-content-between"
              style={{ padding: "16px 20px 16px 20px" }}
            >
              <div className="dashboardLiveClassesText">Upcoming Classes</div>
              <div
                className="dashboardThisWeek d-flex align-items-center"
                style={{ gap: "8px" }}
              >
                {selectionValues[liveclassesSelection]}
                <DashboardDropdown onItemSelect={setLiveclassesSelection} />
              </div>
            </div>
            <hr style={{ margin: "0px" }} />
            <div
              style={{
                height: isMobileView ? "300px" : "200px",
                overflowY: "auto",
              }}
            >
              {liveClassesLoader ? (
                <div
                  style={{
                    height: isMobileView ? "300px" : "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Spinner animation="border" />
                </div>
              ) : liveClassesList.length === 0 ? (
                <div
                  style={{
                    height: isMobileView ? "300px" : "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {" "}
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#1D2026",
                    }}
                  >
                    No Upcoming Live Classes
                  </div>
                </div>
              ) : (
                liveClassesList.map((upComingClass, index) => {
                  const liveClassdate = new Date(
                    upComingClass.startDateTime,
                  ).toDateString();
                  const liveClassTime = formatAMPM(
                    new Date(upComingClass.startDateTime),
                  );
                  return (
                    <div
                      key={index}
                      className="d-flex justify-content-between"
                      style={{ padding: "12px 20px 12px 20px" }}
                    >
                      <div
                        className="d-flex align-items-center"
                        style={
                          isMobileView
                            ? { justifyContent: "space-between", width: "100%" }
                            : {}
                        }
                      >
                        <div
                          className="dashboardUpcomingDate"
                          style={!isMobileView ? { marginRight: "30px" } : {}}
                        >
                          {liveClassdate} at {liveClassTime}
                        </div>
                        <div>
                          <StatusChip status={upComingClass.status} />
                        </div>
                      </div>
                      <div>
                        {upComingClass.status === "Live" ? (
                          <PlayRecordingButton
                            style={{ marginLeft: "12px" }}
                            className="start-classroom-styles"
                            variant="outline-primary"
                            classRoomId={classroomId}
                            onClick={() => {
                              startLiveClass(
                                upComingClass._id,
                                upComingClass.meetingID,
                                upComingClass.attendeePW,
                              );
                            }}
                            subjects={upComingClass.subjects} // Pass the subjects array
                          >
                            Join
                          </PlayRecordingButton>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6" style={{ marginBottom: "24px" }}>
          <div className="suggestionCardTitleStyles">
            Get Started with Self-Paced Study
          </div>
          <EnrollementInfoCard
            thumbnail={thumbnail}
            title={`Welcome to ${courseName} Powerprep`}
            description="Want to learn at your own pace? Watch our bite-sized concept videos and master each concept with ease."
            isMobileView={isMobileView}
            onButtonClick={() => {
              navigate(`/student/myClassrooms/${classroomId}/conceptvideos`);
            }}
            btnProps={{
              text: "Watch",
            }}
            maxHeightOFCard={isMobileView ? "" : "257px"}
          />
        </div>
        <div style={{ padding: '0px 12px 24px 12px' }}>
          <RecentMistakesWidget studentId={userInformation?._id} classroomId={classroomId} subjectsMap={subjectsMap} onViewAll={() => {
            navigate(`/student/myClassrooms/${classroomId}/dashboard/wrong-questions`)
          }} hasIeltsExams={hasIeltsExams} />
        </div>
        <div className="col-12 col-lg-12" style={{ marginBottom: "24px" }}>
          <div className="card" style={{ padding: "0px", borderRadius: "0px" }}>
            <div
              className="d-flex justify-content-between"
              style={{ padding: "16px 20px 16px 20px" }}
            >
              <div className="dashboardRecentActivitedTitle">
                Your recent activities
              </div>
              <div
                className="dashboardThisWeek d-flex align-items-center"
                style={{ gap: "8px" }}
              >
                {selectionValues[activitySelection]}
                <DashboardDropdown onItemSelect={setActivitySelection} />
              </div>
            </div>
            <hr style={{ margin: "0px" }} />
            <ActivityTabsHeader
              isMobileView={isMobileView}
              tabsList={activitesTabsList}
              activeTab={activeTab}
              onTabChange={(newTab) => {
                setClickTimes(1);
                setActiveTab(newTab);
              }}
            />
            <div style={{ height: "400px", overflowY: "auto" }}>
              {activitesLoader ? (
                <div
                  style={{
                    height: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Spinner animation="border" />
                </div>
              ) : (
                componentsMapping[activeTab]
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(StudentDashboard);
